// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__slvFG","modalError":"styles_modalError___u6QZ"};